import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../../loader/Loader';
import NicheLandingPage from './NicheLandingPage';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

export default function ContractorsMain() {
    const { t, locale } = useLocale();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) return <Loader />;

    return (
        <Fragment>
            <PageSEO title={t('niche.contractors.metaTitle')} description={t('niche.contractors.metaDescription')} path="/contractors" locale={locale} />
            <NicheLandingPage nicheKey="contractors" />
        </Fragment>
    );
}
